import StringUtils from './string-utils';

export function getFilteredProvincesViaAllowedProvinces(currentLanguage: string, allowedProvinces: any): any {
    const provinceListData = getProvinceSelectionModalData(currentLanguage);
    const defaultProvinces = provinceListData.provinces;
    const newProvinces = defaultProvinces.filter(function (province) {
        return allowedProvinces.split(',').includes(province.value);
    });
    if (newProvinces && newProvinces.length) { provinceListData.provinces = newProvinces; }

    return provinceListData;
}
export function getProvinceSelectionModalData(currentLanguage: string): any {

    const uriParams = new URLSearchParams(window.location.search);
    const language = uriParams.get('lang') || 'en';  // Default to 'en'
    console.log('Language used:', language);

    const provinces_en = {
        provincePlaceholder: "Select",
        provinces: [
            { label: "Other Region", value: "OTHERS" },
            { label: "Alberta", value: "AB" },
            { label: "British Columbia", value: "BC" },
            { label: "Manitoba", value: "MB" },
            { label: "Newfoundland and Labrador", value: "NL" },
            { label: "New Brunswick", value: "NB" },
            { label: "Northwest Territories", value: "NT" },
            { label: "Nova Scotia", value: "NS" },
            { label: "Nunavut", value: "NU" },
            { label: "Ontario", value: "ON" },
            { label: "Prince Edward Island", value: "PE" },
            { label: "Quebec", value: "QC" },
            { label: "Saskatchewan", value: "SK" },
            { label: "Yukon", value: "YT" }
        ]
    };

    const provinces_fr = {
        provincePlaceholder: "Sélectionnez",
        provinces: [
            { label: "Autre Région", value: "OTHERS" },
            { label: "Alberta", value: "AB" },
            { label: "Colombie-Britannique", value: "BC" },
            { label: "Manitoba", value: "MB" },
            { label: "Terre-Neuve-et-Labrador", value: "NL" },
            { label: "Nouveau-Brunswick", value: "NB" },
            { label: "Territoires du Nord-Ouest", value: "NT" },
            { label: "Nouvelle-Écosse", value: "NS" },
            { label: "Nunavut", value: "NU" },
            { label: "Ontario", value: "ON" },
            { label: "Île-du-Prince-Édouard", value: "PE" },
            { label: "Québec", value: "QC" },
            { label: "Saskatchewan", value: "SK" },
            { label: "Yukon", value: "YT" }
        ]
    };

    return StringUtils.contains(currentLanguage, 'fr', 0) ? provinces_fr : provinces_en;
}
export default getProvinceSelectionModalData;